import moment from 'moment';
import {
  CUSTOMER_MEETING_PLANNER,
  MEETING_PLANNER_MEETINGS,
  MEETING_SPONSORS,
  REFUSE_INVITATION,
  ACCEPT_INVITATION,
  AVAILABLE_SLOTS_MODAL_ID,
} from './types';

export default {
  [ACCEPT_INVITATION]: (
    state,
    {
      dayIndex, startTime, endTime, invitationIndex,
    },
  ) => {
    let time = startTime;
    const slotInvitation = { ...state.meetingDaysMap[startTime][dayIndex].invitation_request_details[invitationIndex], approved: true, is_proceeded: true };
    do {
      state.meetingDaysMap[time][dayIndex].slot_type = 'meeting';
      state.meetingDaysMap[time][dayIndex].invitation_request_details = [slotInvitation];

      time = moment(`2023-01-01 ${time}`)
        .add(30, 'minutes')
        .format('HH:mm:ss');
    } while (time !== endTime);
  },

  [REFUSE_INVITATION]: (
    state,
    {
      dayIndex, startTime, endTime, invitationIndex,
    },
  ) => {
    console.log('dayIndex, startTime, endTime, invitationIndex->', dayIndex, startTime, endTime, invitationIndex);

    let time = startTime;

    if (invitationIndex !== null) {
      do {
        state.meetingDaysMap[time][dayIndex].invitation_request_details[
          invitationIndex
        ].approved = false;
        state.meetingDaysMap[time][dayIndex].invitation_request_details[
          invitationIndex
        ].is_proceeded = true;
        time = moment(`2023-01-01 ${time}`)
          .add(30, 'minutes')
          .format('HH:mm:ss');
      } while (time !== endTime);
    } else {
      do {
        state.meetingDaysMap[time][dayIndex].slot_type = null;
        state.meetingDaysMap[time][dayIndex].customer_meeting_planner_id = null;
        state.meetingDaysMap[time][dayIndex].invitation_request_details = [];
        time = moment(`2023-01-01 ${time}`)
          .add(30, 'minutes')
          .format('HH:mm:ss');
      } while (time !== endTime);
    }
  },
  [CUSTOMER_MEETING_PLANNER]: (state, payload) => {
    const meetingDaysMap = {};
    state.days = Object.keys(payload.mpSlots)
      .filter(key => payload.mpSlots[key].length > 0)
      .sort((a, b) => new Date(a) - new Date(b));

    Object.entries(payload.mpSlots).forEach(([day, daysData]) => {
      daysData.forEach((timeData) => {
        meetingDaysMap[timeData.start] = meetingDaysMap[timeData.start] || state.days.map(() => null);
        const dayIndex = state.days.indexOf(day);
        meetingDaysMap[timeData.start][dayIndex] = timeData;
      });
    });

    state.times = Object.keys(meetingDaysMap).sort(
      (a, b) => new Date(`1970/01/01 ${a}`) - new Date(`1970/01/01 ${b}`),
    );
    state.meetingDaysMap = meetingDaysMap;
    state.meetingDaysMapForMobile = { ...payload.mpSlots };
    state.mpSlots = payload.mpSlots;
  },
  [MEETING_PLANNER_MEETINGS]: (state, payload) => {
    const meetingDaysMap = {};
    state.days = Object.keys(payload.meetings)
      .filter(key => payload.meetings[key].length > 0)
      .sort((a, b) => new Date(a) - new Date(b));

    Object.entries(payload.meetings).forEach(([day, daysData]) => {
      daysData.forEach((timeData) => {
        meetingDaysMap[timeData.start] = meetingDaysMap[timeData.start] || state.days.map(() => null);
        const dayIndex = state.days.indexOf(day);
        meetingDaysMap[timeData.start][dayIndex] = timeData;
      });
    });
    state.meetingDaysMapForMobile = payload.meetings;

    state.meetings = meetingDaysMap;
  },
  [MEETING_SPONSORS]: (state, { data }) => {
    state.meetingSponsors = data.results.sort(
      (a, b) => a.position + b.position,
    );
  },
  [AVAILABLE_SLOTS_MODAL_ID]: (state, { id }) => {
    state.availableSlotsModalId = id;
  },
};
